import React from 'react';

import styled from '@emotion/styled';

import { IconRawSvg } from '../../../../components/IconRawSvg';
import { useStoryblokStrings } from '../../../../hooks';
import { media } from '../../../../services/media';

export const SwipeForMore = () => {
    const storyblokScoreFactors = useStoryblokStrings('my-score-factors');

    if (!storyblokScoreFactors) {
        return null;
    }

    return (
        <Wrapper>
            <Text>{storyblokScoreFactors.swipe_for_more}</Text>
            <Icon name="swipeIcon" />
        </Wrapper>
    );
};

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 30px;
    margin-bottom: 35px;
`;

const Text = styled.span`
    font-weight: 300;
    line-height: 1;
    display: block;

    ${media.max('lg')} {
        font-size: 20px;
    }

    ${media.min('lg')} {
        font-size: 22px;
    }
`;

const Icon = styled(IconRawSvg)`
    opacity: 0.7;

    ${media.max('lg')} {
        flex: 1 0 54px;
        max-width: 54px;
    }

    ${media.min('lg')} {
        max-width: 60px;
        flex: 1 0 60px;
    }
`;
